import React from "react";
import styles from "../../../styles/brsr/general.module.css";
import { useParams } from "react-router-dom";

const GeneralInstructions = () => {
  const { id } = useParams();
  const handleRedirect = () => {
    window.location.href = `/brsr/section-c/principle1/${id}`;
  };

  return (
    <div className={styles.container}>
      {/* General Instructions Section */}
      <p className={styles.header}>
        SECTION C: PRINCIPLE WISE PERFORMANCE DISCLOSURE
      </p>

      <b>PRINCIPLE 1:</b>
      <p className={styles.paragraph}>
        Businesses should conduct and govern themselves with integrity, and in a
        manner that is Ethical, Transparent and Accountable.
      </p>

      <b>PRINCIPLE 2:</b>
      <p className={styles.paragraph}>
        Businesses should provide goods and services in a manner that is
        sustainable and safe.
      </p>

      <b>PRINCIPLE 3:</b>
      <p className={styles.paragraph}>
        Businesses should respect and promote the well-being of all employees,
        including those in their value chains.
      </p>

      <b>PRINCIPLE 4:</b>
      <p className={styles.paragraph}>
        Businesses should respect the interests of and be responsive to all its
        stakeholders
      </p>

      <b>PRINCIPLE 5:</b>
      <p className={styles.paragraph}>
        Businesses should respect and promote human rights.
      </p>

      <b>PRINCIPLE 6:</b>
      <p className={styles.paragraph}>
        Businesses should respect and make efforts to protect and restore the
        environment.
      </p>

      <b>PRINCIPLE 7:</b>
      <p className={styles.paragraph}>
        Businesses, when engaging in influencing public and regulatory policy,
        should do so in a manner that is responsible and transparent.
      </p>

      <b>PRINCIPLE 8:</b>
      <p className={styles.paragraph}>
        Businesses should promote inclusive growth and equitable development.
      </p>

      <b>PRINCIPLE 9:</b>
      <p className={styles.paragraph}>
        Businesses should engage with and provide value to their consumers in a
        responsible manner.
      </p>

      {/* Continue Button */}
      <div className={styles.buttonContainer}>
        <button className={styles.button} onClick={handleRedirect}>
          Continue →
        </button>
      </div>
    </div>
  );
};

export default GeneralInstructions;
